<template>
  <div class="pb-2 px-4 container-fluid d-flex h-100 flex-column">
    <div class="row g-0">
      <div class="col">
        <h5 class="current">{{ t('billing_summary.current_plan') }}</h5>
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col">
        <div class="row g-1">
          <p class="card-text subscription-plan">{{ billingDetails.subscriptionName }}</p>
        </div>
        <div class="row g-0 pb-0">
          <p class="card-text subscription-price">${{ billingDetails.planPrice }} / {{ t(`billing_summary.${billingDetails.paymentInterval}`) }}</p>
        </div>
        <div class="row g-0">
          <p class="card-text subscription-renewal">{{ t('billing_summary.your_plan_renews_on') }} {{ billingDetails.renewalDate }}</p>
        </div>
      </div>
      <div class="col text-end">
          <button class="btn btn-outline-danger btn-sm rounded-pill mx-2" @click="cancelSubscription"
          :disabled="disableCancel">{{ t('billing_summary.cancel_current_plan') }}</button>
      </div>
    </div>

    <div class="row pt-4" no-gutters>
      <div class="col">
        <h5 class="current">{{ t('billing_summary.cancellation') }}</h5>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="card-text">
          <span class="warning-text">{{ t('billing_summary.warning') }}</span> {{ t('billing_summary.warning_message') }}
        </div>
      </div>
    </div>

    <div class="row flex-grow-1 align-items-end text-end row-bottom pb-3">
      <div class="col align-right">
        <div class="btn-group" role="group">
          <button class="btn btn-primary btn-sm rounded-pill ms-2 action-button" type="button" @click="summary">{{ t('billing_summary.back_to_summary') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Company } from "@authentic-labs/vue-component-library";
  import Billing from "../../models/Billing";
  import { cancelPlan } from "../../services/PaymentService";
  import { useToast } from "vue-toastification";
  import { useStore } from "vuex";
  import { computed, ref, inject } from "vue";
  import { useI18n } from "vue-i18n";

  const $store = useStore();
  const toast = useToast();
  const emitter: any = inject("emitter");
  const { t } = useI18n();

  const prop = defineProps<{
    billingDetails: Billing;
  }>();

  const company = computed((): Company => {
    return $store.getters.company;
  });

  const disableCancel = ref(false);

  function summary() {
    emitter.emit("billing-summary");
  }

  async function cancelSubscription() {
    disableCancel.value = true;
    const response = await cancelPlan();
    if (response === "success") {
      toast.success("Your plan was successfully cancelled");
      emitter.emit("billing-summary", "refresh");
      disableCancel.value = false;
    } else {
      toast.error("A problem occurred when cancelling your account");
    }
  }
</script>

<style scoped>
.go-summary {
  text-decoration: none;
  outline: 0 !important;
  box-shadow: none;
  padding: 0;
}

.current {
  border-bottom: 1px solid lightgray;
  padding-bottom: 1rem;
}

.subscription-plan {
  font-family: "proximanova-bold", sans-serif;
  font-size: 20px;
}

.subscription-price {
  font-family: "proximanova-regular", sans-serif;
  font-size: 20px;
}

.current-plan {
  font-size: 18px;
}

.warning-text {
  color: red;
  font-size: 20px;
  font-family: "proximanova-bold", sans-serif;
}
</style>
